/* IMPORT */
import escape from 'string-escape-regex';
/* MAIN */
const replaceAll = (str, find, replacement) => {
    return str.replace(new RegExp(escape(find), 'g'), replacement);
};
/* EXPORT */
export default replaceAll;
